module.exports = __webpack_public_path__ + "img/daily_specials_5.ab50f4a1.jpg";